import { en } from "@/locales/en";
import { fr } from "@/locales/fr";
import type { Locale } from "@/lib/i18n";

export type Messages = typeof en | typeof fr;

export function getMessages(locale: Locale): Messages {
  return locale === "fr" ? fr : en;
}
